import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { ViewportScroller, DOCUMENT } from '@angular/common';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class CustomViewportScroller implements ViewportScroller {
	private offset: [number, number] = [0, 0];

	constructor(
		@Inject(DOCUMENT) private document: Document,
		@Inject(PLATFORM_ID) private platformId: Object
	) {}

	setOffset(offset: [number, number] | (() => [number, number])): void {
		if (isPlatformBrowser(this.platformId)) {
			if (typeof offset === 'function') {
				this.offset = offset();
			} else {
				this.offset = offset;
			}
		}
	}

	getScrollPosition(): [number, number] {
		if (isPlatformBrowser(this.platformId)) {
			const appElement = this.document.querySelector('app');
			if (appElement) {
				return [appElement.scrollLeft, appElement.scrollTop];
			}
		}
		return [0, 0];
	}

	scrollToPosition(position: [number, number]): void {
		if (isPlatformBrowser(this.platformId)) {
			const appElement = this.document.querySelector('app');
			if (appElement) {
				appElement.scrollLeft = position[0];
				appElement.scrollTop = position[1];
			}
		}
	}

	scrollToAnchor(anchor: string): void {
		if (isPlatformBrowser(this.platformId)) {
			const appElement = this.document.querySelector('app');
			if (appElement) {
				const element = appElement.querySelector(`#${anchor}`);
				if (element) {
					const rect = element.getBoundingClientRect();
					const top =
						rect.top + appElement.scrollTop - this.offset[1];
					appElement.scrollTop = top;
				}
			}
		}
	}

	setHistoryScrollRestoration(restoration: 'auto' | 'manual'): void {
		if (isPlatformBrowser(this.platformId)) {
			if ('scrollRestoration' in history) {
				history.scrollRestoration = restoration;
			}
		}
	}
}
